import React from 'react';
import AppDiscountBanner from './AppDiscountBanner';
import GrandOpeningBanner from './GrandOpeningBanner';
import HolidayBanner from './HolidayBanner';

/**
 * @param {object} props
 * @param {FF.Location} props.locationData
 * */
export default function PromotionalBanner({ locationData }) {
  if (locationData.type !== 'FRIDGE') {
    return null;
  }

  const {
    featureFlags: {
      isGrandOpening = false,
      isLowTierDiscount = false,
      isMidTierDiscount = false,
      isHolidayMode = false,
      holidayType,
    } = {},
  } = locationData;

  if (isHolidayMode && holidayType) {
    return <HolidayBanner type={holidayType} />;
  }

  if (isGrandOpening) {
    return <GrandOpeningBanner />;
  }

  if (isLowTierDiscount || isMidTierDiscount) {
    return <AppDiscountBanner showFreeMealPromo={isMidTierDiscount} />;
  }

  return null;
}
